import { LowerCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import { CollectiveInvoiceIssueTerm } from '../../enums/collective-invoice-issue-term';
import type { ContractorInvoice } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-invoice-collective-issue-term',
  imports: [TranslatePipe, LowerCasePipe],
  templateUrl: './contractor-invoice-collective-issue-term.component.html',
  styleUrl: './contractor-invoice-collective-issue-term.component.scss',
})
export class ContractorInvoiceCollectiveIssueTermComponent {
  public readonly invoice = input.required<ContractorInvoice>();
  public readonly label = input('labels.shipping');

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly CollectiveInvoiceIssueTerm = CollectiveInvoiceIssueTerm;
}
